import React from "react";

/**
 * This is a very rudimentary HoC for deferring loading of components onto the
 * frontend. This should only be used for things outside the critical
 * path/where performance isn't important. It accepts an promise that should
 * resolve as { default: componentFn }.
 */
export default function (importedComponent) {
  class AsyncComponent extends React.Component {
    constructor(props) {
      super(props);

      this.state = { component: null };
    }

    componentDidMount() {
      return importedComponent().then(({ default: component }) => {
        this.setState({ component });
      });
    }

    render() {
      const Component = this.state.component;

      return Component ? <Component {...this.props} /> : null;
    }
  }

  return AsyncComponent;
}
